import {
    HandThumbUpIcon
  } from "@heroicons/react/24/outline";
  import { classNames } from "../../tools/ClassNames"

export const CambioConInstrucciones = ({ color1='bg-gray-400', color2='bg-gray-400', color3='bg-gray-400'}) => {
  let timeline = [
    {
      id: 1,
      content: "Tu contraseña debe tener un mínimo de 6 caracteres y un maximo de 30 caracteres.",
      target: "",
      href: "#",
      date: "Sep 20",
      datetime: "2020-09-20",
      icon: HandThumbUpIcon,
      iconBackground: color1,
    },
    {
      id: 2,
      content: "Tu contraseña debe contener al menos un número.",
      target: "",
      href: "#",
      date: "Sep 22",
      datetime: "2020-09-22",
      icon: HandThumbUpIcon,
      iconBackground: color2,
    },
    {
      id: 3,
      content: "La contraseña no debe contener espacios.",
      target: "",
      href: "#",
      date: "Sep 28",
      datetime: "2020-09-28",
      icon: HandThumbUpIcon,
      iconBackground: color3,
    },
  ];
  return (
    <div className="flow-root">
        <label
        className="mb-6"
        >  </label>
      <ul role="list" className="-mb-8">
        {timeline.map((event, eventIdx) => (
          <li key={event.id}>
            <div className="relative pb-6">
              {eventIdx !== timeline.length - 1 ? (
                <span
                  className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                  aria-hidden="true"
                />
              ) : null}
              <div className="relative flex space-x-3">
                <div>
                  <span
                    className={classNames(
                      event.iconBackground,
                      "h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                    )}
                  >
                    <event.icon
                      className="h-5 w-5 text-white"
                      aria-hidden="true"
                    />
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                  <div>
                    <p className="text-sm text-white">
                      {event.content}{" "}
                      <a
                        href={event.href}
                        className="font-medium text-gray-900"
                      >
                        {event.target}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
